export const theme = {
  primaryColor: '#8c30da',
  secondaryColor: 'rgb(255, 255, 255)'
};

export const offsetColor = ([red, green, blue], offset) => {
  return `rgb(${clipColor(red, offset)}, ${clipColor(green, offset)}, ${clipColor(blue, offset)})`;
};

const clipColor = (color, diff) => {
  const value = color + diff;
  return value > 0 ? value < 255 ? value : 255 : 0;
};